import { logGreyError } from 'owa-analytics';
import { isOfflineSyncEnabled } from 'owa-offline-sync-feature-flags';
import { isOfflineBootEnabled } from 'owa-offline/lib/offlineBoot';

export function timeZonesGetter<T extends () => Promise<any>>(
    action: T
): Promise<Awaited<ReturnType<T>> | undefined> {
    if (!isOfflineBootEnabled() || !isOfflineSyncEnabled()) {
        return Promise.resolve(undefined);
    }

    return action().catch((err: Error) => {
        reportError(err);
        return undefined;
    });
}

const reportError = (error: Error) => {
    /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param, owa-custom-rules/telemetry-event-name-format -- (https://aka.ms/OWALintWiki)
     * BASELINE: DO NOT COPY/PASTE!
     * undefined
     *	> Argument at index 1 for logGreyError must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo
     (https://aka.ms/OWALintWiki)
         * Baseline. Dev touching this file must update to pass the active MailboxInfo; Docs: https://aka.ms/owa-analytics-mailboxinfo
         * undefined
         *	> MailboxInfo must be passed into the function to identify the account.
         (https://aka.ms/OWALintWiki)
             * Baseline. DO NOT COPY AND PASTE! Grandfathering existing event names; Devs who touch this file should update Event Names to follow Outlook Telemetry Naming Standards
             *	> Invalid Outlook telemetry EventName "offline_tz_error": must start with a capital letter (A–Z). */
    logGreyError('offline_tz_error', undefined, error);
};
